export async function loadNetworkData() {
  try {
    const response = await fetch('/network-data.json');
    const data = await response.json();
    console.log(`Loaded ${data.nodes.length} nodes and ${data.links.length} links`);
    return data;
  } catch (error) {
    console.error('Error loading network data:', error);
    return { nodes: [], links: [] };
  }
}
